import { AppPage } from '../../components/general';

const Billing = () => {
  return (
    <AppPage title="Billing" breadcrumbs="Home - Billing">
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-white text-2xl mb-4 bg-[#0a1f3d]">
          <i className="pi pi-wallet" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Billing</h2>
        <p className="text-gray-400 max-w-md">
          Billing is coming soon.
        </p>
      </div>
    </AppPage>
  );
};

export default Billing;
